<div class="pro-info" [ngClass]="{ warning: warning }">
  <img [src]="iconUrl" class="icon" />
  <div class="pro-info-message" [innerHtml]="getTranslation(message)"></div>
  <div class="pro-info-link" (click)="tryPro()">
    {{ button | translate }}
  </div>
</div>
